<template>
  <div class="mx-auto py-4">
    <div style="display: flex; justify-content: right; padding-right: 2%; background-color: #efefef !important;">
      <v-switch v-model="reportCategory" :label="
        `${ reportCategory === true
          ? 'Accredited Course Report'
          : 'NON Accredited Course Report'
        }`
      " class="black--text"></v-switch>
    </div>
    <v-card v-if="reportCategory === true" class="mx-4 my-2" flat>
      <v-card-title>
        Accredited Course Report
        <v-spacer></v-spacer>
        <div class="ml-12">
          <download-excel :data="cat2Selected" :fields="cat2_export_fields" name="CourseReport.xls"
                          type="csv">
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>

      </v-card-title>
      <v-data-table
          v-model="cat2Selected"
          :headers="cat2Headers"
          :items="accreditedCourseReports.rows"
          :loading="cat2loading"
          :options.sync="cat2options"
          :server-items-length="accreditedCourseReports.count"
          class="elevation-1"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-2" xs3>
              <v-text-field
                  v-model="nameValue"
                  hide-details
                  label="Course Name"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="codeValue"
                  hide-details
                  label="Course Code"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="ceuValue"
                      label="CEU"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="ceuComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="courseLevelValue"
                  :clearable="clearable"
                  :items="COURSE_LEVELS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Course Level"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="durationValue"
                      label="Course Duration"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="durationComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="courseOwnerValue"
                  :clearable="clearable"
                  :items="CPD_PROVIDERS"
                  :loading="lookupLoading"
                  item-text="trainingCenterName"
                  item-value="id"
                  label="Course Owner"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="courseAccreditorValue"
                  :clearable="clearable"
                  :items="ACCREDITORS"
                  :loading="lookupLoading"
                  item-text="accreditorName"
                  item-value="id"
                  label="Course Accreditor"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="accreditationStartDateValue" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="accreditationStartDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="accreditationEndDateValue" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="accreditationEndDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout
          >
        </template>
      </v-data-table>
    </v-card>
    <v-card v-else class="mx-4 my-2" flat>
      <v-card-title>
        NON Accredited Course Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel :data="selected" :fields="export_fields" name="PreServiceDetailReport.xls" type="csv">
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="nonAccreditedCourseReports.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="nonAccreditedCourseReports.count"
          class="elevation-1"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-2" xs3>
              <v-text-field
                  v-model="non_nameValue"
                  hide-details
                  label="Course Name"
                  single-line
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="non_ceuValue"
                      label="CEU"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="non_ceuComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="non_courseLevelValue"
                  :clearable="clearable"
                  :items="COURSE_LEVELS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Course Level"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="non_durationValue"
                      label="Course Duration"
                      type="number"
                  ></v-text-field
                  >
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="non_durationComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="non_courseOwnerValue"
                  :clearable="clearable"
                  :items="CPD_PROVIDERS"
                  :loading="lookupLoading"
                  item-text="trainingCenterName"
                  item-value="id"
                  label="Course Owner"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="non_startDateValue" :clearable="true" persistent-hint
                                placeholder="Start Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="non_startDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu ref="menu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="non_endDateValue" :clearable="true" persistent-hint
                                placeholder="End Date" prepend-icon="mdi-calendar" v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="non_endDateValue"
                    no-title
                    scrollable
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {CourseReportService} from "./course-report-service";
import accreditationSummaryReport
  from "@/components/Reports/accreditation-summary-report/accreditation-summary-report.vue";
import {AccreditorService} from "@/components/Accreditors/accreditor.service";
import {TrainingCenterService} from "@/components/TrainingCenter/training_center.service";
import {getCourseLevel} from "@/utils/helper";

export default {
  computed: {
    accreditationSummaryReport() {
      return accreditationSummaryReport
    }
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      nonAccreditedCourseReports: [],
      headers: [
        {text: "Course Name", value: "courseName"},
        {text: "CEU", value: "continualEducationUnit"},
        {text: "Course Level", value: "courseLevel.name"},
        {text: "Course Duration", value: "courseDuration"},
        {text: "Passing Score", value: "passingScore"},
        {text: "Owner Name", value: "courseOwner.trainingCenterName"},
        {text: "Owner Email", value: "courseOwner.institutionEmailAddress"},
        {text: "Owner Phone", value: "courseOwner.institutionPhoneNumber"},
        {text: "Created Date", value: "createdAt"},
      ],
      export_fields: {
        "Course Name": "courseName",
        "CEU": "continualEducationUnit",
        "Course Level": "courseLevel.name",
        "Course Duration": "courseDuration",
        "Passing Score": "passingScore",
        "Owner Name": "courseOwner.trainingCenterName",
        "Owner Email": "courseOwner.institutionEmailAddress",
        "Owner Phone": "courseOwner.institutionPhoneNumber",
        "Created Date": "createdAt",
      },
      selected: [],

      cat2options: {
        page: 1,
        itemsPerPage: 10,
      },
      accreditedCourseReports: [],
      cat2Headers: [
        {text: "Course Name", value: "courseName"},
        {text: "Course Code", value: "courseCode"},
        {text: "CEU", value: "continualEducationUnit"},
        {text: "Course Level", value: "courseLevel.name"},
        {text: "Course Duration", value: "courseDuration"},
        {text: "Passing Score", value: "passingScore"},
        {text: "Owner Name", value: "courseOwner.trainingCenterName"},
        {text: "Owner Email", value: "courseOwner.institutionEmailAddress"},
        {text: "Owner Phone", value: "courseOwner.institutionPhoneNumber"},
        {text: "Accreditor Name", value: "courseAccreditor.accreditorName"},
        {text: "Accreditor Email", value: "courseAccreditor.institutionalEmail"},
        {text: "Accreditor Phone", value: "courseAccreditor.institutionalPhone"},
        {text: "Accreditation Date", value: "courseAccreditationDate"},
      ],
      cat2_export_fields: {
        "Course Name": "courseName",
        "Course Code": "courseCode",
        "CEU": "continualEducationUnit",
        "Course Level": "courseLevel.name",
        "Course Duration": "courseDuration",
        "Passing Score": "passingScore",
        "Owner Name": "courseOwner.trainingCenterName",
        "Owner Email": "courseOwner.institutionEmailAddress",
        "Owner Phone": "courseOwner.institutionPhoneNumber",
        "Accreditor Name": "courseAccreditor.accreditorName",
        "Accreditor Email": "courseAccreditor.institutionalEmail",
        "Accreditor Phone": "courseAccreditor.institutionalPhone",
        "Accreditation Date": "courseAccreditationDate",
      },
      cat2Selected: [],

      reportCategory: true,

      lookupLoading: false,
      clearable: true,
      loading: false,
      cat2loading: false,

      COURSE_LEVELS: [],
      CPD_PROVIDERS: [],
      ACCREDITORS: [],

      nameValue: null,
      codeValue: null,
      ceuValue: null,
      ceuComparisonValue: null,
      courseLevelValue: null,
      durationValue: null,
      durationComparisonValue: null,
      courseOwnerValue: null,
      courseAccreditorValue: null,
      accreditationStartDateValue: null,
      accreditationEndDateValue: null,

      non_nameValue: null,
      non_ceuValue: null,
      non_ceuComparisonValue: null,
      non_courseLevelValue: null,
      non_durationValue: null,
      non_durationComparisonValue: null,
      non_courseOwnerValue: null,
      non_startDateValue: null,
      non_endDateValue: null,

      comparisons: [
        {name: "=", value: "eq"},
        {name: "<", value: "lt"},
        {name: ">", value: "gt"},
        {name: "<=", value: "lte"},
        {name: ">=", value: "gte"},
      ],
    };
  },
  async beforeMount() {
    await this.fetchAccreditedCourseReport();
    await this.initateLookups();
    await this.fetchNonAccreditedCourseReport();
  },
  watch: {
    nameValue: function (val) {
      this.nameValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    codeValue: function (val) {
      this.codeValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    ceuValue: function (val) {
      this.ceuValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    ceuComparisonValue: function (val) {
      this.ceuComparisonValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    courseLevelValue: function (val) {
      this.courseLevelValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    durationValue: function (val) {
      this.durationValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    durationComparisonValue: function (val) {
      this.durationComparisonValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    courseOwnerValue: function (val) {
      this.courseOwnerValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    courseAccreditorValue: function (val) {
      this.courseAccreditorValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    accreditationStartDateValue: function (val) {
      this.accreditationStartDateValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },
    accreditationEndDateValue: function (val) {
      this.accreditationEndDateValue = val == '' ? null : val;
      this.fetchAccreditedCourseReport();
    },

    non_nameValue: function (val) {
      this.non_nameValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_ceuValue: function (val) {
      this.non_ceuValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_ceuComparisonValue: function (val) {
      this.non_ceuComparisonValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_courseLevelValue: function (val) {
      this.non_courseLevelValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_durationValue: function (val) {
      this.non_durationValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_durationComparisonValue: function (val) {
      this.non_durationComparisonValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_courseOwnerValue: function (val) {
      this.non_courseOwnerValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_startDateValue: function (val) {
      this.non_startDateValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
    non_endDateValue: function (val) {
      this.non_endDateValue = val == '' ? null : val;
      this.fetchNonAccreditedCourseReport();
    },
  },
  methods: {
    async initateLookups() {
      this.lookupLoading = true;
      const accreditorList = await AccreditorService.getAllAccreditorsList();
      this.ACCREDITORS = accreditorList?.data?.rows;
      const cpdProviderList = await TrainingCenterService.getAllTrainingCenters();
      this.CPD_PROVIDERS = cpdProviderList?.data?.rows;
      this.COURSE_LEVELS = await getCourseLevel();
      this.lookupLoading = false;
    },
    async fetchNonAccreditedCourseReport() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;

      let searchParams = '?isAccredited=false&';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.non_nameValue !== null && (searchParams += '&name=' + this.non_nameValue);
      this.non_ceuValue !== null && (searchParams += '&ceu=' + this.non_ceuValue);
      this.non_ceuComparisonValue !== null && (searchParams += '&ceuSign=' + this.non_ceuComparisonValue);
      this.non_courseLevelValue !== null && (searchParams += '&courseLevelId=' + this.non_courseLevelValue);
      this.non_durationValue !== null && (searchParams += '&courseDuration=' + this.non_durationValue);
      this.non_durationComparisonValue !== null && (searchParams += '&durationSign=' + this.non_durationComparisonValue);
      this.non_courseOwnerValue !== null && (searchParams += '&trainingCenterId=' + this.non_courseOwnerValue);
      this.non_startDateValue !== null && (searchParams += '&creationStartDate=' + this.non_startDateValue);
      this.non_endDateValue !== null && (searchParams += '&creationEndDate=' + this.non_endDateValue);

      const res = await CourseReportService.getCourses(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.nonAccreditedCourseReports = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Non Acredited course reports, Please try Again!"
        );
      }
    },
    async fetchAccreditedCourseReport() {
      this.cat2loading = true;
      const {page, itemsPerPage} = this.cat2options;

      let searchParams = '?isAccredited=true&';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.nameValue !== null && (searchParams += '&name=' + this.nameValue);
      this.codeValue !== null && (searchParams += '&courseCode=' + this.codeValue);
      this.ceuValue !== null && (searchParams += '&ceu=' + this.ceuValue);
      this.ceuComparisonValue !== null && (searchParams += '&ceuSign=' + this.ceuComparisonValue);
      this.courseLevelValue !== null && (searchParams += '&courseLevelId=' + this.courseLevelValue);
      this.durationValue !== null && (searchParams += '&courseDuration=' + this.durationValue);
      this.durationComparisonValue !== null && (searchParams += '&durationSign=' + this.durationComparisonValue);
      this.courseOwnerValue !== null && (searchParams += '&trainingCenterId=' + this.courseOwnerValue);
      this.courseAccreditorValue !== null && (searchParams += '&courseAccreditorId=' + this.courseAccreditorValue);
      this.accreditationStartDateValue !== null && (searchParams += '&accreditationStartDate=' + this.accreditationStartDateValue);
      this.accreditationEndDateValue !== null && (searchParams += '&accreditationEndDate=' + this.accreditationEndDateValue);

      const res = await CourseReportService.getCourses(searchParams);
      if (res) {
        this.cat2loading = false;
        this.accreditedCourseReports = res.data;
      } else {
        this.cat2loading = false;
        this.$toast.error(
            "There was a problem fetching accredited Course reports, Please try Again!"
        );
      }
    },
  },
};
</script>
